'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./radio-button.scss');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function RadioButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      reverse = _ref.reverse,
      size = _ref.size,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'disabled', 'reverse', 'size', 'style']);

  var classes = (0, _classnames2.default)('radio-button', className, disabled && 'radio-button--disabled', 'radio-button--' + size);

  return _react2.default.createElement(
    'label',
    { className: classes, style: style },
    _react2.default.createElement('input', _extends({
      type: 'radio',
      className: 'radio-button__input',
      disabled: disabled
    }, props)),
    reverse && _react2.default.createElement(
      'span',
      { className: 'radio-button__label' },
      children
    ),
    _react2.default.createElement(_icon2.default, { name: 'dot', className: 'radio-button__icon' }),
    !reverse && _react2.default.createElement(
      'span',
      { className: 'radio-button__label' },
      children
    )
  );
}

RadioButton.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  style: _propTypes2.default.object
};

RadioButton.defaultProps = {
  size: 'medium'
};

exports.default = RadioButton;